import React, { useState, useEffect, useContext } from 'react'
import { useHistory } from 'react-router-dom'
import { getVerifyEmail } from '../api'
import { GoHome, Progress } from '../components'
import { AppContext } from '../context'
import { FeedbackContext } from '../feedback'
import { translate } from '../i18n'
import { User } from '../model'
import { RouterParams } from '../router'

export default function VerifyEmail({ match }: RouterParams) {
    const history = useHistory()
    const context = useContext(AppContext)
    const feedbackContext = useContext(FeedbackContext)
    const [status, setStatus] = useState<string>('loading')
    const [user, setUser] = useState<User>()

    useEffect(() => {
        setStatus('loading')
        getVerifyEmail(match.params.code)
            .then((response) => {
                setUser(response)
                setStatus('loaded')
            })
            .catch((error) => {
                setStatus(error.message)
            })
    }, [match.params.code])

    if (status === 'loading') {
        return <Progress />
    }

    if (context.session) {
        if (status === 'loaded') {
            feedbackContext.showSuccess(
                translate('auth.verify_email.success') as string
            )
        } else {
            feedbackContext.showError(status)
        }

        history.push('/profile')
        return <></>
    }

    if (status !== 'loaded') {
        return <GoHome message={status} />
    }

    return (
        <GoHome
            title={translate('auth.verify_email.title') as string}
            message={
                translate('auth.verify_email.success_anonymous', {
                    email: user!.email,
                }) as string
            }
        />
    )
}
